import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { applyServiceWorkerUpdate, onServiceWorkerUpdate } from '../../lib/offline/register';
import { useOnline } from '../../lib/offline/useOnline';
import { DURATION, EASE_OUT_EXPO } from '../../lib/motion';

/**
 * Two status strips that share one slot at the top of the page.
 *
 * Losing the network is worth saying out loud: without it, a failed save reads
 * as a bug in the app rather than as "you are in a tunnel".
 *
 * A pending update is offered, never applied. Reloading the page under someone
 * who is mid-way through editing a day would lose their work to a cosmetic
 * upgrade.
 */
export function OfflineBar() {
  const online = useOnline();
  const [updateReady, setUpdateReady] = useState(false);

  useEffect(() => onServiceWorkerUpdate(() => setUpdateReady(true)), []);

  const visible = !online || updateReady;

  return (
    <AnimatePresence>
      {visible ? (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: DURATION.fast, ease: EASE_OUT_EXPO }}
          className="overflow-hidden"
        >
          {!online ? (
            <div className="bg-sun-500/20 px-4 py-2 text-center text-sm">
              📴 Нет сети. Путешествия, открытые на этом устройстве, читаются как обычно; изменения не сохранятся.
            </div>
          ) : (
            <div className="flex flex-wrap items-center justify-center gap-3 bg-lagoon-500/15 px-4 py-2 text-center text-sm">
              <span>Вышла новая версия приложения.</span>
              <button
                type="button"
                onClick={() => void applyServiceWorkerUpdate()}
                className="link-underline font-medium text-lagoon-600 dark:text-lagoon-300"
              >
                Обновить
              </button>
              <button
                type="button"
                onClick={() => setUpdateReady(false)}
                className="text-xs text-[var(--text-muted)] hover:text-[var(--text-strong)]"
              >
                позже
              </button>
            </div>
          )}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
